import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { Input, Row, Table } from "antd";

import productApi from "../../../../apis/Product.api";
import { setLoading } from "../../../../redux/store/common/commonDuck";

const CooperatePickProduct = ({
  isDisabled,
  selectedRows,
  setSelectedRows,
  selectedRowKeys,
  setSelectedRowKeys,
}) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [productItemList, setProductItemList] = useState([]);
  const [searchWord, setSearchWord] = useState("");

  const copyRegisterColumns = [
    {
      title: "카테고리",
      dataIndex: "product_category_name",
      key: "product_category_name",
      ellipsis: true,
      render: (value) => {
        if (value === "") {
          return <span>-</span>;
        } else {
          return value;
        }
      },
    },
    {
      title: "브랜드명",
      dataIndex: "product_brand_name",
      key: "product_brand_name",
      ellipsis: true,
    },
    {
      title: "제품명",
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
    },
  ];

  const rowSelection = {
    type: "radio",
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedRows(selectedRows);
    },
    getCheckboxProps: () => ({
      disabled: isDisabled,
    }),
  };

  useEffect(() => {
    readProductList();
  }, []);

  /**
   * 상품 리스트 가져오기
   * @returns {Promise<void>}
   */
  const readProductList = async () => {
    setIsLoading(true);
    try {
      let res = await productApi.readProductListAll(
        0,
        "",
        "",
        "",
        "product_id",
        "desc",
        user.id === 724 ? 1 : user.id,
      );
      if (res.code === 200) {
        setProductItemList(res.result);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        alert("정상적인 요청이 아닙니다.");
      }
    } catch (error) {
      setIsLoading(false);
      // setError(error);
      console.log("readProductList read error", error);
    }
  };

  return (
    <>
      <Row
        className="product-register-border-box"
        wrap={false}
        style={{ marginTop: 20 }}
      >
        <span className="product-register-box-title">공동구매 상품 등록</span>
        <span className="product-register-box-sign">*</span>
      </Row>
      <Row
        className="product-register-border-box"
        wrap={false}
        style={{
          borderTop: 0,
          padding: "30px 33px",
          height: 300,
          flexDirection: "column",
          rowGap: "20px",
          alignItems: "start",
        }}
      >
        <Input.Search
          name="product_name"
          value={searchWord}
          disabled={isDisabled}
          onChange={(e) => setSearchWord(e.target.value)}
          placeholder={`공구를 진행 할 상품명을 검색해주세요.`}
          // onSearch={handleProductSearch}
          style={{
            width: "50%",
          }}
        />
        <Table
          rowSelection={rowSelection}
          columns={copyRegisterColumns}
          dataSource={
            isDisabled
              ? selectedRows
              : productItemList.filter(
                  (item) =>
                    item.product_category_name.includes(searchWord) ||
                    item.product_brand_name.includes(searchWord) ||
                    item.product_name.includes(searchWord),
                )
          }
          loading={isLoading}
          tableLayout={"auto"}
          bordered
          size="small"
          rowKey="product_id"
          className={"table-class"}
          rowClassName="coupon-table-row"
          scroll={{
            // x: 1500,
            y: "calc(300px - 11em)",
          }}
          // onChange={handleTableChange}
          pagination={false}
          style={{
            width: "80%",
          }}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                setSelectedRowKeys([record.product_id]);
                setSelectedRows([record]);
              },
            };
          }}
        />
      </Row>
    </>
  );
};

export default CooperatePickProduct;
